import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { pushError } from '@core/monitoring';
import { PAGE_TITLES, usePageTitle } from '@core/utils/page-title.util';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-page',
  imports: [TranslateModule],
  template: `
    <div class="flex flex-col items-center h-screen bg-white text-black">
      <img src="/assets/icons/emoji-sad.svg" class="w-40" alt="Sad face" />

      <h1 class="font-normal text-[2.5rem] text-inherit mb-6">
        Server Error {{ code }}
      </h1>
      <p>
        @if (code === 500) {
          There is a problem with the resource you are looking for, and it
          cannot be displayed.
        } @else {
          The resource you are looking for could not be found. The url might be
          mistyped or the resource have been removed, had its name changed, or
          is temporarily unavailable.
        }
      </p>
      <p>Please try again later.</p>
    </div>
  `,
})
export class ErrorPageComponent implements OnInit {
  code?: number;
  private setPageTitle = usePageTitle();
  private route = inject(ActivatedRoute, { optional: true });

  ngOnInit() {
    this.code = history.state.data;
    this.setPageTitle(PAGE_TITLES.ERROR.key, PAGE_TITLES.ERROR.fallback);

    // Log error to Faro when error page is displayed
    // Only log if faro is available (not in tests)
    if (typeof window !== 'undefined') {
      const errorCode =
        this.code || this.route?.snapshot.params['code'] || 'unknown';
      const currentUrl = window.location.href;

      try {
        pushError(new Error(`Error page displayed: ${errorCode}`), {
          error_code: String(errorCode),
          url: currentUrl,
          page: 'error-page',
        });
      } catch (e) {
        // Silently fail if Faro is not initialized (e.g., in tests)
        console.debug('Faro error logging failed:', e);
      }
    }
  }
}
